import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withCookies } from 'react-cookie';
import { Container } from '../styles/Container';

class CookieBar extends React.Component {
  constructor(props) {
    super(props);
    this.handleAccept = this.handleAccept.bind(this);
  }
  
  handleAccept() {
    const { cookies } = this.props;
    const d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    cookies.set('cookie_valamagasinet', 'cookie_valamagasinet', { path: '/', expires: d });
  }
  
  render() {
    const { cookies } = this.props;
    const cookieAccepted = cookies.get('cookie_valamagasinet') !== undefined;
    
    if (cookieAccepted)
      return null;
    
    return (
      <CookieBarContainer>
        <CookieBarContentContainer>
          <CookieTextContainer>
            <CookieImage src='/images/icons/cookies.svg' />
            <CookieText>
              <p>Vi sparar cookies för att förbättra upplevelsen på Valamagasinet.se</p>
              <p><a href="/kundservice/integritetspolicy" target='_blank'>Läs mer om cookies</a></p>
            </CookieText>
          </CookieTextContainer>
          <CookieBtn onClick={() => this.handleAccept()} type="button">
            Jag godkänner!
          </CookieBtn>
        </CookieBarContentContainer>
      </CookieBarContainer>
    );
  }
}

const breakpoint = '900px';

const CookieBarContainer = styled.div`
  position: fixed;
  z-index: 800;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  margin: 0;
  padding: 0;
  border-top: 1px solid #c1c1c1;
`;

const CookieBarContentContainer = Container.extend`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  padding-bottom: 14px;
  
  @media screen and (min-width: ${breakpoint}) {
    flex-direction: row;
    padding-top: 24px;
    padding-bottom: 24px;
  }
`;

const CookieImage = styled.img`
  width: 41px;
  height: 35px;
  margin-right: 19px;
  
  @media screen and (min-width: ${breakpoint}) {
    width: 60px;
    height: 50px;
    margin-right: 23px;
  }
`;

const CookieTextContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  
  @media screen and (min-width: ${breakpoint}) {
    margin-bottom: 0;
  }
`;

const CookieText = styled.div`
  font-size: 13px;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: #000;

  > p {
    margin: 0;
  }
  
  a {
    text-decoration: none;
    text-transform: uppercase;
    color: black;
    font-weight: 600;
    letter-spacing: 1.5px;
    font-size: 12px;
    margin-top: 5px;
    display: inline-block;
    transition: opacity .25s ease-out;
    
    &:hover {
      opacity: .5;
    }
  }
  
  @media screen and (min-width: ${breakpoint}) {
    font-size: 14px;
  }
`;

const CookieBtn = styled.button`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  text-decoration: none;
  min-width: 160px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border: none;
  background-color: #779182;
  cursor: pointer;
  margin-left: 0;
  width: 100%;
  transition: opacity .25s ease-out;
  
  &:hover {
    opacity: .85;
  }
  
  @media screen and (min-width: ${breakpoint}) {
    max-width: 192px;
    min-height: 50px;
  }
`;

CookieBar.propTypes = {
  cookies: PropTypes.object.isRequired
};

export default withCookies(CookieBar);



// WEBPACK FOOTER //
// ./src/components/CookieBar.js